var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 286,
    viewBox: "0 0 315 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.957 186.901L133.589 151.008L134.018 150.579C158.283 123.659 176.407 91.799 187.139 57.2H229.091V28.6H128.864V0H100.227V28.6H0V57.2H159.934C150.341 84.656 135.164 110.825 114.545 133.705C101.23 118.976 90.2045 102.817 81.4705 85.8H52.8341C63.2864 109.109 77.6045 131.131 95.5023 151.008L22.6227 222.794L42.9545 243.1L114.545 171.6L159.075 216.073L169.957 186.901ZM250.568 114.4H221.932L157.5 286H186.136L202.173 243.1H270.184L286.364 286H315L250.568 114.4ZM213.055 214.5L236.25 152.581L259.445 214.5H213.055Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageIcon);
export default __webpack_public_path__ + "static/media/language_icon.764f0dd4bb5bb57cdb2c33097e9a991c.svg";
export { ForwardRef as ReactComponent };